import { UPLOAD_SIGN } from "../constants/constants";

export const uploadsign = (value) => {
  return {
    type: UPLOAD_SIGN,
    payload: value,
  };
};
